import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getPersonaAfferenza } from 'uniba-volto-persone/actions';
import { NavLink } from 'react-router-dom';

function extractPathFromUrl(url) {
    if (!url) {
        return null;
    }
    const pattern = /\/rubrica\/[^\s]*/;
    const match = url.match(pattern);
    if (match) {
        return match[0];
    }
    return null;
}

class SchedaPersonaAfferenza extends Component {
    componentDidMount() {
        const { path, getPersonaAfferenza } = this.props;
        getPersonaAfferenza(path);
    }

    componentDidUpdate(prevProps) {
        const { path, getPersonaAfferenza } = this.props;
        if (path !== prevProps.path) {
            getPersonaAfferenza(path);
        }
    }

    render() {
        const { path, content, loading, intl } = this.props;

        if (loading) {
            return <p>Caricamento in corso...</p>;
        }

        const afferenze = content[path];

        if (!afferenze || afferenze.length === 0) {
            return (
                <div className="alert alert-warning" role="alert">
                    {intl.formatMessage({ id: "warn_afferenza_da_definire" })}
                </div>
            );
        }
        const user_path = extractPathFromUrl(path);
        return (
            <ul>
                {afferenze?.map((item, index) => {
                    const isResponsabile = item.responsabile?.some(
                        (responsabile) => responsabile.path === user_path
                    );
                    const responsabileLabel = isResponsabile
                        ? (item.labelResponsabile || "Responsabile")
                        : null;
                    const intl_responsabileLabel = responsabileLabel
                        ? intl.formatMessage({ id: responsabileLabel })
                        : null;
                    return (
                        <li key={item.path} id={index === 0 ? "afferenza-utente" : undefined}>
                            <NavLink to={item.path}>
                                {item.title}
                                {responsabileLabel && (
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic', marginLeft: '5px' }}>
                                        - {intl_responsabileLabel}
                                    </span>
                                )}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

SchedaPersonaAfferenza.propTypes = {
    path: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
    content: state.personaAfferenzaReducer.items,
    loading: state.personaAfferenzaReducer.loading,
});

const mapDispatchToProps = {
    getPersonaAfferenza,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SchedaPersonaAfferenza));
